import { render, staticRenderFns } from "./V2CartErrors.vue?vue&type=template&id=bbf3fdbc&scoped=true&"
import script from "./V2CartErrors.vue?vue&type=script&lang=js&"
export * from "./V2CartErrors.vue?vue&type=script&lang=js&"
import style0 from "./V2CartErrors.vue?vue&type=style&index=0&id=bbf3fdbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf3fdbc",
  null
  
)

export default component.exports